import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router/index.js'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import PrimeVue from 'primevue/config';
import "primevue/resources/themes/aura-light-blue/theme.css";
import "primevue/resources/primevue.min.css"; //core CSS
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';

import "primeflex/primeflex.css";
import Tooltip from 'primevue/tooltip';
import Badge from 'primevue/badge';
import BadgeDirective from 'primevue/badgedirective';


// import "primeflex/themes/primeone-light.css";
// import "primeicons/primeicons.css";

import Button from '@/components/common/elements/Button.vue'
import Label from '@/components/common/elements/Label.vue'
import Input from '@/components/common/elements/Input.vue'
import Checkbox from '@/components/common/elements/Checkbox.vue'
import Radio from '@/components/common/elements/Radio.vue'
import Select from '@/components/common/elements/Select.vue'
import Textarea from '@/components/common/elements/Textarea.vue'

// Log application version
const appVersion = __APP_VERSION__ || '1.0.0';
console.log(`EZtoBIZ v${appVersion}`);

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
const app = createApp(App)
app.use(router)
app.use(PrimeVue);
app.use(ConfirmationService);
app.use(ToastService);


app.component('ElButton', Button)
app.component('ElLabel', Label)
app.component('ElInput', Input)
app.component('ElCheckbox', Checkbox)
app.component('ElRadio', Radio)
app.component('ElSelect', Select)
app.component('ElTextarea', Textarea)
app.directive('tooltip', Tooltip);
app.directive('badge', BadgeDirective);

app.use(pinia)
app.mount('#app')
